export const getEhrRoute = (linkType, personId, subjectType, subjectId) => {
  const ehrstateObj = JSON.parse(sessionStorage.getItem("ehrstate"));
  const ehrSessionId = ehrstateObj.session.sessionId;
  const ehrBaseroute = "/".concat(ehrSessionId, "/2/patient/").concat(personId);
  if (linkType === 'client') {
    return "".concat(ehrBaseroute, "/referrals");
  } else if (linkType === 'topic') {
    return "".concat(ehrBaseroute, "/").concat(subjectType, "s/").concat(subjectId);
  }
};
//# sourceMappingURL=getEhrRoute.js.map